import React from "react";
import TitleCell from "./cells/TitleCell";
const customColumnRenderers = {
  attributes: {
    type: {
      staticWidth: 140
    },
    name: {
      renderCell: (name, collectionEntity) => /* @__PURE__ */ React.createElement(TitleCell, { name, id: collectionEntity.id, type: collectionEntity.type })
    }
  }
};
export default customColumnRenderers;
